import axios from 'axios'

export default {
    namespaced: true,
    actions: {
        selectionList({dispatch}, filter) {
            return new Promise((resolve, reject) => {
                axios.get(
                    '/api/manager/events/selection-list', {params: filter }
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                    reject(error)
                })
            })
        },
        fetch({commit, dispatch}, filter) {
            return new Promise((resolve, reject) => {
                commit('TOGGLE_PRELOADER', true, {root: true})
                axios.get(
                    '/api/manager/events/list', { params: filter }
                ).then(({data}) => {
                    resolve(data.data)
                }).finally(() => {
                    commit('TOGGLE_PRELOADER', false, {root: true})
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                    reject(error)
                })
            })
        },
        add({commit, dispatch}, data) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/manager/events/add',
                    prepareData(data)
                ).then(({data}) => {
                    resolve(data.data)
                }).catch(error => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        edit({commit, dispatch}, editedItem) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/manager/events/edit/' + editedItem.id,
                    prepareData(editedItem)
                ).then(({data}) => {
                    resolve(data.data)
                }).catch(error => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        delete({commit, dispatch}, itemId) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/manager/events/dell/' + itemId
                ).then(() => {
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
    }
}

function prepareData (data) {
    const fd = new FormData()
    if (data.image) {
        fd.append('image', data.image)
    }
    fd.append('name', data.name)
    fd.append('intro', data.intro)
    fd.append('price', data.price)
    fd.append('date', data.date)
    fd.append('hotel_id', data.hotel_id)
    if (data.description) {
        fd.append('description', data.description)
    }
    if (data.price_value) {
        fd.append('price_value', data.price_value)
    }
    fd.append('published', Number(data.published))
    fd.append('is_places', Number(data.is_places))

    return fd
}
